<template>
    <div id="chargePanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="charge_panel">
                <div class="panel_header">
                    <div class="header_title">来自懒人办公团队的一封信</div>
                </div>
                <div class="panel_content">
                    <div class="letter_title">尊敬的{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}，您好:</div>
                    <div class="letter_line">系统发现您是初次体验懒人办公，非常感谢您把第一次献给了我们，我们感到无比的荣幸！</div>
                    <div class="letter_line">为了让您更好的体验，不会让金钱妨碍您体验懒人办公的光芒，我们特为您准备一张 <span class="coupon">{{coupon_money}}元优惠券</span>，<span class="condition">仅限新人注册当天使用，次日失效</span> ！</div>
                    <div class="letter_line">优惠券已经自动发放，请尽快使用!过了今日，可能留下的满是遗憾！</div>
                    <div class="letter_footer">希望能在写作上对您有帮助的: 懒人办公<br/>{{date_time}}</div>
                </div>
                <div class="panel_footer">
                    <el-button class="skip" style="width:250px;" @click="skip('skip')">小爷有的是钱，点此飘过</el-button>
                    <el-button style="width:250px;" type="info" @click="skip('use')">非常感谢，点此立即使用</el-button>
                </div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                date_time:"",
                coupon_money:""
            }
        },
        created() {
            let date = new Date();
            let y = date.getFullYear(),m = date.getMonth()+1,d = date.getDate();
            this.date_time = y + "年" + m + "月" + d + "日";
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            }
        },
        methods: {
            show(coupon_money){
                this.coupon_money = coupon_money
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
            skip(action){
                this.$emit('skip',action);
                this.$refs.popup.close();
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .charge_panel{
        width: 600px;
        position: relative;
        padding: 24px 32px 38px;
        background-color: #fff;
        border-radius: 5px;
        .panel_header{
            .header_title{
                width: 386px;
                height: 98px;
                margin: 0 auto;
                background-size: 100% 100%;
                background-image: url("./img/img_icon_14.png");
                font-size: 16px;
                color: #000;
                line-height: 24px;
                text-align: center;
            }
        }
        .panel_content{
            line-height: 34px;
            .letter_title{
                margin-bottom: 20px;
            }
            .letter_line{
                text-indent: 2em;
                margin-bottom: 16px;
                span{
                    padding: 0 8px;
                    border-radius: 3px;
                    line-height: 28px;
                    display: inline-block;
                    text-indent: 0;
                }
                .coupon{
                    background-color: #ffffcc;
                    color: #f00;
                }
                .condition{
                    background-color: #eee;
                    color: #07c160;
                }
            }
            .letter_footer{
                padding-top: 20px;
                text-align: right;
                line-height: 38px;
            }
        }
        .panel_footer{
            margin-top: 36px;
            display: flex;
            justify-content: space-between;
            .skip{
                background-color: #e3e3e3;
                color: #999;
                &:hover{
                    border-color: #e3e3e3;
                }
            }
        }
    }
</style>